// Modules
import cn from 'classnames';

// Types
import type { TCardMediaProps } from './Card.type';

// Styles
import styles from './styles.module.scss'

const CardMedia = (props: TCardMediaProps) => {
	const {
		children,
		className,
		...restProps
	} = props

	const cardMediaCN = cn(styles.legion_card_media, className)

	return (
		<div className={cardMediaCN} {...restProps}>
			{children}
		</div>
	)
}

export default CardMedia;
